export default __webpack_public_path__ + "static/media/interoperability.715376fd.svg";